import axiosServices from "../utils/axios";

import type { OnBoardServiceVendor } from "../utils/types/type-helper";

interface FetchApiResponce {
  charterer: OnBoardServiceVendor[];
  delivery_vendor_vendors: OnBoardServiceVendor[];
  bunkers_freshwater_suppliers: OnBoardServiceVendor[];
  surveyor: OnBoardServiceVendor[];
  on_board_service_vendors: OnBoardServiceVendor[];
  terminals: OnBoardServiceVendor[];
  job_id: string;
}

interface companyResponse {
  data: FetchApiResponce;
}
export const fetchCompanyList = async (
  jobId: String,
  showCompletedBerths: boolean = true
) => {
  let url = `/jobs/${jobId}/companies`;
  if (!showCompletedBerths) url += `?showCompletedBerths=false`;
  const response = await axiosServices.get<companyResponse>(url);
  return response?.data?.data;
};
